import React from 'react'
import {connect} from 'react-redux'
import buscarMapaVeiculoItinerario from '../../actions/mapa-veiculo/buscarMapaVeiculoItinerario'
import Titulo from '../comum/Titulo';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import trocarPoltrona from '../../actions/reserva/trocarPoltrona';
import {groupArrayOfObjects} from '../../util/arraysUtil';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';

const ModalConfirmacaoAlteracaoPoltrona = ({ alterarPoltrona, reserva, poltrona }) => (
  <div className="modal fade" id="modalConfirmacaoAlteracaoPoltrona" tabIndex="-1" role="dialog"
       aria-labelledby="modalConfirmacaoAlteracaoPoltrona" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>
        <div className="vx-modal-header">
          <div className="vx-modal-title">
            <span className="material-icons">event_seat</span>
            Confirmar Alteração de Poltrona
          </div>
          <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
            <span className="material-icons">close</span>
          </button>
        </div>
        <div className="vx-modal-body">
          <p style={{fontSize: '14px', color: '#444', lineHeight: '1.7', margin: 0}}>
            Alterar a poltrona do(a) passageiro(a){' '}
            <strong style={{color: '#1a1a1a'}}>{reserva ? reserva.passageiroDto.nome : null}</strong>{' '}
            do número{' '}
            <strong style={{color: '#FF6A00', fontSize: '16px'}}>{reserva ? reserva.numeroPoltrona : null}</strong>
            {' '}para o número{' '}
            <strong style={{color: '#FF6A00', fontSize: '16px'}}>{poltrona ? poltrona.numero : null}</strong>?
          </p>
        </div>
        <div className="vx-modal-footer">
          <button id='cancelar' type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
            Não
          </button>
          <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                  onClick={() => alterarPoltrona()}>
            <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
            Sim, alterar
          </button>
        </div>
      </div>
    </div>
  </div>
);

export class PainelAlteracaoPoltrona extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      reserva: null,
      poltrona: null,
      reservas: props.reservasSelecionadas
    };
  }

  componentDidMount () {
    if (this.state.reservas && this.state.reservas.length) {
      if (Object.entries(groupArrayOfObjects(this.state.reservas, 'itinerarioId')).length > 1) {
        showErrorMsg('Não é permitido alterar poltronas de itinerários diferentes');
        this.props.history.push('/painel-remarcacao');
      }
      let reserva = this.state.reservas[0];
      this.props.buscarItinerario(this.props.empresaSelecionada.id, reserva.itinerarioId);
    } else {
      this.props.history.push('/painel-remarcacao');
    }
  }

  selecionarPoltrona (poltrona) {
    this.setState({ poltrona: poltrona })
  }

  selecionarReserva (reserva) {
    if (this.state.reserva && this.state.reserva.id === reserva.id) {
      this.setState({ reserva: null })
    } else {
      this.props.buscarMapaVeiculoItinerario(reserva.itinerarioId, reserva.idCidadeOrigem, reserva.idCidadeDestino, true);
      this.setState({ reserva: reserva })
    }
  }

  alterarPoltrona () {
    const parametros = {
      reservaId: this.state.reserva.id,
      poltronaId: this.state.poltrona.id,
      itinerarioId: this.props.itinerarioSelecionado.id,
      empresaId: this.props.empresaSelecionada.id
    };

    this.props.trocarPoltrona(parametros)
      .then(() => {
          showSuccessMsg('Poltrona alterada com sucesso');
          this.props.buscarMapaVeiculoItinerario(this.state.reserva.itinerarioId, this.state.reserva.idCidadeOrigem, this.state.reserva.idCidadeDestino, true);
          this.setState({ reserva: Object.assign({}, this.state.reserva, { numeroPoltrona: this.state.poltrona.numero }) });
          let reservas = this.state.reservas.filter(f => f.id !== this.state.reserva.id);
          reservas.push(this.state.reserva);
          this.setState({ reservas: reservas });
      })
  }

  renderReserva (reserva, indice) {
    const selecionada = this.state.reserva && this.state.reserva.id === reserva.id;
    return (
      <li key={`acao${indice}`}
          className={`vx-ap-passenger-item${selecionada ? ' vx-ap-passenger-item--selected' : ''}`}
          onClick={() => this.selecionarReserva(reserva)}>
        <div className="vx-ap-passenger-icon">
          <span className="material-icons">person</span>
        </div>
        <div className="vx-ap-passenger-info">
          <div className="vx-ap-passenger-name">{reserva.passageiroDto.nome}</div>
          <div className="vx-ap-passenger-seat">
            Poltrona atual:{' '}
            <span className="vx-ap-passenger-seat-badge">
              <span className="material-icons">event_seat</span>
              {reserva.numeroPoltrona}
            </span>
          </div>
        </div>
        <div className="vx-ap-passenger-arrow">
          <span className="material-icons">
            {selecionada ? 'keyboard_arrow_down' : 'chevron_right'}
          </span>
        </div>
      </li>
    );
  }

  exibirReservas () {
    if (this.state.reservas.length) {
      return (
        <div className="vx-ap-passengers-card">
          <div className="vx-ap-passengers-header">
            <span className="material-icons">people</span>
            Selecione o passageiro para alterar a poltrona
          </div>
          <ul className="vx-ap-passenger-list">
            {this.state.reservas.map((reserva, index) => this.renderReserva(reserva, index))}
          </ul>
        </div>
      );
    }
  }

  montarMapa () {
    if (this.props.mapaVeiculoItinerarioIda && this.props.mapaVeiculoItinerarioIda.length) {
      return (this.props.mapaVeiculoItinerarioIda.map(fileira =>
        <React.Fragment key={fileira.id}>
          <div>
            {this.exibirFileira(fileira)}
          </div>
          {this.exibirCorredor(fileira)}
        </React.Fragment>))
    }
  }

  exibirCorredor (fileira) {
    return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.id}`}/> : '')
  }

  // eslint-disable-next-line class-methods-use-this
  exibirFileira (fileira) {
    if (fileira.assentos.length > 0) {
      return (
        <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
          {this.exibirAssentos(fileira)}
          <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
        </div>
      )
    }
  }

  exibirAssentos (fileira) {
    return fileira.assentos.map(assento => <div key={`assento-${this.props.sentido}-${fileira.numero}-${assento.ordem}`}>
      {this.exibirAssento(assento)}
    </div>)
  }

  exibirAssento (assento) {
    const { poltrona } = assento;
    if (assento.tipoAssento !== 'NORMAL') {
      return <label key={assento.id} className="espaco-vago js-seat-selected-amplitude"></label>
    }
    if (!poltrona || poltrona.bloqueada) {
      return <label data-toggle="tooltip" data-html="true" key={assento.id} className="assento assento-ocupado" style={{
        backgroundColor: 'red',
        color: '#FFF'
      }}>{poltrona.numero}</label>
    }
    if (!poltrona || poltrona.reservada) {
      return <label data-toggle="tooltip" data-html="true" key={assento.id} className="assento assento-ocupado">{poltrona.numero}</label>
    }
    return (
      <label key={assento.id} style={!assento.selecionado ? {
        backgroundColor: '#02c659',
        color: '#FFF'
      } : null}
             className={`assento assento-disponivel js-seat-selected-amplitude ${assento.selecionado ? 'assento-selecionado' : ''}`}>
        {poltrona.numero}
        <input type="checkbox" name={poltrona.id} id={poltrona.id} data-assento={poltrona.numero}
               onClick={() => this.selecionarPoltrona(poltrona)}
               data-toggle="modal"
               data-target="#modalConfirmacaoAlteracaoPoltrona"
               value={poltrona.numero}/>
      </label>
    )
  }

  exibirMapa () {
    const reserva = this.state.reserva;
    return (
      <div className="vx-ap-map-card">
        <div className="vx-ap-map-header">
          <span className="material-icons">event_seat</span>
          Selecione a nova poltrona
          {reserva &&
            <span className="vx-ap-map-header-sub">
              {reserva.passageiroDto.nome} · Poltrona atual: {reserva.numeroPoltrona}
            </span>
          }
        </div>
        <div className="vx-ap-map-body">
          <div className="vx-ap-seat-legend">
            <div className="vx-ap-seat-legend-item">
              <div className="vx-ap-legend-dot" style={{background: '#02c659'}}></div>
              Disponível
            </div>
            <div className="vx-ap-seat-legend-item">
              <div className="vx-ap-legend-dot" style={{background: '#FFC107'}}></div>
              Ocupado
            </div>
            <div className="vx-ap-seat-legend-item">
              <div className="vx-ap-legend-dot" style={{background: 'red'}}></div>
              Bloqueado
            </div>
          </div>
          <div className="transport-result-wrapper transport-result-wrapper-connection" data-wrapper-direction="">
            <div className="js-count-transport">
              <div className="transport bus-design bus-design-side">
                <div className="transport-frente"/>
                <div className="transport-meio transport-meio-thin">
                  {this.montarMapa()}
                </div>
                <div className="transport-traseira"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render () {
    if (this.state.reservas && this.state.reservas.length) {
      const reserva = this.state.reservas[0];
      return (
        <div className="row internas">
          <Titulo texto="Alteração de poltrona" urlRetorno="/painel-remarcacao"/>
          <div className='col-12 conteudo-internas conteudo-painel'>
            <div className="vx-ap-container">

              <div className="vx-ap-route-header">
                <div className="vx-ap-route-title">
                  {reserva.descCidadeOrigem}
                  <span className="material-icons vx-ap-route-arrow">arrow_forward</span>
                  {reserva.descCidadeDestino}
                </div>
                <div className="vx-ap-route-times">
                  <div className="vx-ap-route-time">
                    <span className="vx-ap-route-time-label">Saída</span>
                    <span className="vx-ap-route-time-value">{this.props.itinerarioSelecionado.dataHoraPartida}</span>
                  </div>
                  <div className="vx-ap-route-time">
                    <span className="vx-ap-route-time-label">Chegada</span>
                    <span className="vx-ap-route-time-value">{this.props.itinerarioSelecionado.dataHoraChegada}</span>
                  </div>
                </div>
              </div>

              {this.exibirReservas()}
              {this.state.reserva ? this.exibirMapa() : ''}

            </div>
          </div>
          <ModalConfirmacaoAlteracaoPoltrona
            alterarPoltrona={this.alterarPoltrona.bind(this)}
            reserva={this.state.reserva}
            poltrona={this.state.poltrona}/>
        </div>
      )
    }
    return '';
  }
}


export const mapStateToProps = state => (
  {
    poltronasSelecionadas: state.poltronasSelecionadas,
    mapaVeiculoItinerarioIda: state.mapaVeiculoItinerarioIda,
    reservasSelecionadas: state.remarcacao.reservasSelecionadas,
    itinerarioSelecionado: state.itinerarioSelecionado,
    empresaSelecionada: state.empresaSelecionada
  });


export default connect(mapStateToProps, {
  buscarMapaVeiculoItinerario,
  buscarItinerario,
  trocarPoltrona
})(PainelAlteracaoPoltrona)
